<template>
    <v-flex xl12>
        <h2>Pesquisa de satisfação <span class="text-title-header"> | Participações</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'surveys',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
